import { ENGAGEMENT_BY_WEBSITE } from './../config';

const reducer = (state = null, action) => {
    switch (action.type) {
        case ENGAGEMENT_BY_WEBSITE:
            return action.payload;
        default:
            return state;
    }
}

export default reducer;
